import { Fragment } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarLetter, Menu, AvatarWithLabel } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useFeatureFlag } from 'shared/domains/featureFlag';
import { useAccount, useAccounts, SSORestricted, activeAccount } from 'shared/domains/users';
export function CompanySelector(props) {
    var _a;
    const { onShowCreateCompanyDialog } = props;
    const canCreateCompany = useFeatureFlag('feature_create_company');
    const account = useAccount();
    const accounts = useAccounts();
    const activeCompany = (_a = account.data) === null || _a === void 0 ? void 0 : _a.companyId;
    const filteredAccounts = accounts;
    const handleSelectAccount = (selection) => {
        const { id, company } = selection;
        const { marketCode } = company;
        activeAccount.set(id);
        // eslint-disable-next-line react-compiler/react-compiler
        window.location.href = `${window.location.origin}/${marketCode}`;
    };
    return (<Fragment>
      <Menu.Label>
        <Trans comment="User menu: my companies list header text">My companies</Trans>
      </Menu.Label>

      {filteredAccounts.map(({ id, company }) => (<Menu.Item key={id} selected={activeCompany === company.id} onClick={() => handleSelectAccount({ id, company })}>
          <AvatarWithLabel size="sm" appearance="light" title={company.name}>
            <AvatarLetter>{company.name[0]}</AvatarLetter>
          </AvatarWithLabel>
        </Menu.Item>))}

      {canCreateCompany && (<SSORestricted>
          <Menu.Item onClick={onShowCreateCompanyDialog}>
            <AvatarWithLabel size="sm" appearance="secondary" title={t({ message: 'Add company', comment: 'User menu: add company button' })}>
              <Falcon icon="plus"/>
            </AvatarWithLabel>
          </Menu.Item>
        </SSORestricted>)}
    </Fragment>);
}
